import styled from 'styled-components';

import { TableContainer } from '@mui/material';

export const ActionsContainer = styled('div')`
  display: flex;
  gap: 0.5rem;
  justify-content: center;
`;

export const StyledTableContainer = styled(TableContainer)(() => ({
  '& .MuiTable-root': {
    borderCollapse: 'collapse',
  },
  '& .MuiTableCell-root': {
    padding: '4px 8px',
    fontSize: '14px',
    lineHeight: 1.2,
    color: '#666666',
    borderBottom: '1px solid #ddd',
  },
  '& .MuiTableHead-root .MuiTableCell-root': {
    fontSize: '15px',
    fontWeight: 'normal',
    backgroundColor: '#f1f1f1',
    color: '#263C6A',
    borderBottom: '2px solid #b3b3b3',
    padding: '8px 12px',
    height: '25px',
    width: 'auto',
    minWidth: 'unset',
    maxWidth: '100%',
    whiteSpace: 'nowrap',
  },
  '& .MuiTableBody-root .MuiTableRow-root:hover': {
    backgroundColor: '#f9f9f9',
  },
  '& .MuiIconButton-root': {
    padding: 4,
  },
}));
